//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Facet.js";
import "../no/Builder.js";
import "../no/SelectDisplayableObject.js";
import "../Facet/Facet.SelectFacetedBody.js";
import "../Facet/Facet.PaintBrushBuilder.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/FacetCollector.js";
import "../no/SelectObject.js";
let d=[[[0,"FacetCollector",0,"FacetCollector",0],[1,"InheritBodyColorPick",0,"SelectDisplayableObject",0],[1,"InheritColorPick",0,"Facet.SelectFacetedBody",1],[1,"PaintBrush",0,"Facet.PaintBrushBuilder",1],[1,"PaintBrushSize",0,"Expression",1]],[[["nPaintBrushColor"],"GetPaintBrushColor",{R_:{paintBrushColor:""}},0,0],[["paintBrushColor"],"SetPaintBrushColor",{},1,0],[["bodies"],"SetupBodyColorData",{},1,0],[["facets"],"SetupColorData",{},1,1],[["bodies"],"PaintBodiesBackgroundColor",{},1,0],[["facets"],"PaintFacetsBackGroundColor",{},1,1],[[],"PaintSelectedFacets",{},0,0]],[]];
SPLM.Facet.PaintFacetBodyBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Facet.PaintFacetBodyBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;